"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseImageIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var Image_1 = require("../Image");
var toDimensions = function (size) {
    if (size === void 0) { size = 32; }
    return typeof size === 'number' ? { width: size, height: size } : size;
};
exports.BaseImageIcon = (0, react_1.forwardRef)(function BaseImageIcon(_a, ref) {
    var _b;
    var src = _a.src, _c = _a.alt, alt = _c === void 0 ? '' : _c, _d = _a.size, size = _d === void 0 ? 32 : _d, imgProps = _a.imgProps, sx = _a.sx, className = _a.className, style = _a.style;
    var _e = toDimensions(size), width = _e.width, height = _e.height;
    var imageStyle = (0, react_1.useMemo)(function () {
        var baseStyle = {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        };
        return (imgProps === null || imgProps === void 0 ? void 0 : imgProps.style) ? __assign(__assign({}, baseStyle), imgProps.style) : baseStyle;
    }, [imgProps === null || imgProps === void 0 ? void 0 : imgProps.style]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", ref: ref, className: className, sx: __assign({ display: 'inline-flex', width: width, height: height, overflow: 'hidden', flexShrink: 0 }, sx), style: style, children: (0, jsx_runtime_1.jsx)(Image_1.Image, __assign({ src: src, alt: alt, width: width, height: height, loading: (_b = imgProps === null || imgProps === void 0 ? void 0 : imgProps.loading) !== null && _b !== void 0 ? _b : 'lazy' }, imgProps, { style: imageStyle })) }));
});
